module.exports = __webpack_public_path__ + "99ac3308dd8ee14f749f51538d0d5b9e.woff";